import { useEffect } from "react"

import DelayedCloseButton from "../../components/DelayedCloseButton/DelayedCloseButton"
import FeatureTermsList from "../../components/FeatureTermsList/FeatureTermsList"
import BubbleFeatureList from "../../components/BubbleFeatureList/BubbleFeatureList"
import Terms from "../../components/Terms/Terms"
import YearlyOnlyAppStoreFooter from "../../components/YearlyOnlyAppStoreFooter/YearlyOnlyAppStoreFooter"
import FullScreenPage from "../../components/FullScreenPage/FullScreenPage"
import SocialProofBanner from "../../components/SocialProofBanner/SocialProofBanner"
import { useAppState } from "../../context/appStateContext"
import { useUltimateAlerts } from "../../context/ultimateAlertsContext"
import { PurchasProvider, usePurchase } from "../../context/purchaseContext"
import { UltimateAlertsProvider } from "../../context/ultimateAlertsContext"
import useStrings from "../../localization/useStrings"
import useQueryParams from "../../hooks/useQueryParams"
import native from "../../native/native"
import styles from "./YearlyOnlyAppStorePaywall.module.scss"

const BubbleFeatureTermsList = () => {
  return (
    <div className={styles.bubbleFeatureTermsList}>
      <BubbleFeatureList />
      <Terms />
    </div>
  )
}

const YearlyOnlyAppStorePaywallContent = () => {
  const { actions } = useAppState()
  const { showBubbleFeatures } = useQueryParams()

  useEffect(() => {
    actions.setFooterInsetColor("var(--background)")
  }, [])

  return (
    <div className={styles.container}>
      <Header />
      <SocialProofBanner />
      <div className={styles.scrollableList}>
        {showBubbleFeatures ? <BubbleFeatureTermsList /> : <FeatureTermsList />}
      </div>
      <YearlyOnlyAppStoreFooter />
    </div>
  )
}

const Header = () => {
  const strings = useStrings()
  const { actions } = useUltimateAlerts()
  const { state } = usePurchase()
  const beforeYouGoEnabled = state.beforeYouGoEnabled
  const hasTrial = state.selectedProduct.hasTrial

  const handleClose = () => {
    if (beforeYouGoEnabled) {
      actions.setShowBeforeYouGo(true)
    } else {
      native.postNativeEvent("close")
    }
  }

  const titleText = hasTrial
    ? strings.socialProof.titleWithTrial
    : strings.socialProof.title

  return (
    <div className={styles.headerContainer}>
      <DelayedCloseButton
        className={styles.closeButton}
        onClick={handleClose}
      />
      <img className={`yellowProLogo ${styles.logo}`} />
      <h1 className={styles.title} style={{ whiteSpace: "pre-line" }}>
        {titleText}
      </h1>
    </div>
  )
}

const YearlyOnlyAppStorePaywall = () => {
  return (
    <PurchasProvider>
      <UltimateAlertsProvider>
        <FullScreenPage>
          <YearlyOnlyAppStorePaywallContent />
        </FullScreenPage>
      </UltimateAlertsProvider>
    </PurchasProvider>
  )
}

export default YearlyOnlyAppStorePaywall
